export const LAIS_TRACKING_EVENTS = Object.freeze({
  LISTING_CLICKED: 'listing.clicked',
  LISTING_CARD_VIEWED: 'listing.card_viewed',
  LISTING_VIEWED: 'listing.viewed',
  LISTING_SHARE_CLICKED: 'listing.share_clicked',
  LISTING_CAROUSEL_CHANGED: 'listing.carousel_changed',
  LISTING_ALERT_CENTER_CLICKED: 'listing.alert_center_clicked',
  LISTING_QUICK_FILTER_CLICKED: 'listing.quick_filter_clicked',
  LISTING_SEARCH_EXPANDED: 'listing.search_expanded',
  LISTING_FILTER_REMOVED: 'listing.filter_removed',
  PAGE_VIEWED: 'page.viewed',
  TARGET_SET: 'lais_target_set',
  TARGET_BULK_APPLIED: 'lais_target_bulk_applied',
  TARGET_RESET_TO_DEFAULT: 'lais_target_reset_to_default',
  COMMISSION_VIEWED: 'lais_commission_viewed',
  COMMISSION_PERIOD_CLOSED: 'lais_commission_period_closed',
  COMMISSION_TARGET_SET: 'lais_commission_target_set',
  COMMISSION_EXPORTED: 'lais_commission_exported',
  PRICING_REPORT_LINK_CLICKED: 'pricing_report_link_clicked',
  PRICING_REPORT_OPENED: 'pricing_report_opened',
  PRICING_REPORT_SECTION_VIEWED: 'pricing_report_section_viewed',
  PRICING_REPORT_CTA_CLICKED: 'pricing_report_cta_clicked',
  PRICING_REPORT_CLOSED: 'pricing_report_closed',
});

export const QUINTO_TRACKING_EVENT_FAMILIES = Object.freeze({
  agenda: [
    'agenda_visit_list_page_viewed',
    'agenda_visit_detail_page_viewed',
    'agenda_visit_card_clicked',
    'agenda_day_tab_changed',
    'agenda_new_visit_clicked',
    'agenda_visit_detail_action_clicked',
    'agenda_visit_detail_houseId_copied',
    'agenda_visit_detail_listing_clicked',
    'agenda_visit_detail_suggestion_viewed',
    'agenda_visit_detail_suggestion_clicked',
    'agenda_visit_cancellation_confirmed',
    'visit_cancel_page_viewed',
    'agenda_visit_dialog_reschedule_clicked',
    'agenda_visit_cancellation_continue_clicked',
    'shortcut_more_visits_viewed',
    'shortcut_more_visits_intent_clicked',
    'shortcut_more_visits_review_page_viewed',
    'shortcut_more_visits_visit_scheduling_clicked',
    'shortcut_more_visits_success_page_viewed',
    'shortcut_more_visits_error_page_viewed',
    'shortcut_more_visits_entry_point_clicked',
    'client_profile_button_clicked',
    'agenda_visit_detail_send_message_clicked',
    'agenda_visit_detail_new_visit_clicked',
    'visit_details_third_party_info_clicked',
    'agenda_visit_detail_alert_status_confirmed',
    'visit_details_unavailable_chat_info_clicked',
    'visit_details_secretary_whatsapp_link_clicked',
    'visit_details_prepare_briefing_widget_view',
    'visit_details_prepare_briefing_button_clicked',
    'new_visit_schedule_date',
    'whtsppciqtpa_agentspwa_pagevisita_clicked',
    'chatcrpp_access_chat_clicked',
    'chatcrpp_access_chat_lr_clicked',
    'owner_contact_open_clicked',
    'owner_contact_close_clicked',
  ],
  visit: [
    'new_visit_page_viewed',
    'confirm_new_visit_register',
    'confirm_new_visit_schedule',
    'new_visit_schedule_time',
    'new_visit_no_keys_viewed',
    'new_visit_url_copied',
    'new_visit_register_date_yesterday',
    'reschedule_page_viewed',
    'confirm_visit_reschedule',
    'new_visit_pageview',
    'new_visit_close_clicked',
    'new_visit_client_selected',
    'new_visit_client_search_typed',
    'new_visit_house_selected',
    'new_visit_house_search_typed',
    'new_visit_date_selected',
    'new_visit_confirm_clicked',
    'new_visit_success_page_viewed',
    'new_visit_success_new_visit_clicked',
    'new_visit_success_agenda_clicked',
    'error_creating_visit',
    'new_visit_modal_opened',
    'new_visit_datetime_with_warning_selected',
    'initiate_visit_confirmation_button_clicked',
    'confirm_visit_page_viewed',
    'confirm_visit_button_clicked',
    'visit_confirmed',
    'visit_stalled',
    'visit_unsuccessful',
    'visit_finalization_agent_dialog_button_clicked',
    'agenda_visit_detail_talk_to_tenant',
    'visit_details_best_practices_living_tenant',
    'call_living_tenant',
    'whatsapp_living_tenant',
    'tenant_living_continue_reschedule',
  ],
  offer: [
    'offer_pageview',
    'offer_details_pageview',
    'offer_tab_clicked',
    'offer_refresh_button_clicked',
    'offer_quick_filters_clicked',
    'offer_filters_type_clear_clicked',
    'offer_details_chat_button_clicked',
    'offer_filters_recent_activities_apply_clicked',
    'offer_filters_recent_activities_clear_clicked',
    'offer_error_refresh_button_clicked',
    'offer_status_list_error_refresh_button_clicked',
    'offer_create_confirm_clicked',
    'offer_created',
    'offer_create_error',
  ],
  entryInfo: [
    'entrance_info_page_viewed',
    'entrance_info_find_property_clicked',
    'entrance_info_property_viewed',
    'entrance_info_url_copied',
    'entrance_info_search_submitted',
    'entrance_info_new_visit_clicked',
    'entrance_info_outside_region',
    'entrance_info_invalid_id',
    'whtsppciqtpa_agentspwa_pageimovel_clicked',
  ],
  crm: [
    'crm_home_page_viewed',
    'crm_home_search_clicked',
    'crm_home_filters_clicked',
    'crm_home_quickfilter_clicked',
    'crm_home_listorder_clicked',
    'crm_home_openprofile_clicked',
    'crm_home_options_clicked',
    'crm_home_clear_filters_clicked',
    'crm_home_error_page_viewed',
    'crm_home_error_refresh_clicked',
    'crm_search_page_viewed',
    'crm_search_typed',
    'crm_search_result_clicked',
    'crm_search_next_page_clicked',
    'crm_filters_page_viewed',
    'crm_filters_submitted',
    'crm_filters_cleared',
    'crm_options_close_clicked',
    'crm_options_chat_clicked',
    'crm_options_call_clicked',
    'crm_options_newvisit_clicked',
    'crm_options_openprofile_clicked',
    'crm_charts_page_viewed',
    'crm_charts_filter_clicked',
    'crm_charts_card_clicked',
  ],
  ownerContact: [
    'owner_contact_open_clicked',
    'owner_contact_close_clicked',
    'owner_contact_terms_conditions_page_viewed',
    'owner_contact_reason_page_viewed',
    'owner_contact_success_page_viewed',
    'owner_contact_request_clicked',
    'owner_contact_accept_continue_clicked',
    'owner_contact_reason_option_clicked',
    'owner_contact_send_message_clicked',
    'owner_contact_phone_call_clicked',
    'lr_contact_open_clicked',
  ],
  rentProgress: [
    'rent_progress_status_page_viewed',
    'rent_progress_status_card_opened',
    'rent_progress_status_filter_clicked',
    'rent_progress_status_filter_submitted',
    'rent_progress_tab_clicked',
    'rent_progress_documentation_filters_apply_clicked',
    'rent_progress_documentation_filters_clear_clicked',
    'rent_progress_contract_filters_apply_clicked',
    'rent_progress_contract_filters_clear_clicked',
    'rent_progress_step_action_clicked',
    'rent_progress_contract_signature_opened',
    'chatcrpp_access_chat_clicked',
  ],
  doneVisits: [
    'finished_schedulings_page_viewed',
    'finished_schedulings_card_opened',
    'finished_schedulings_tab_pending_clicked',
    'finished_schedulings_tab_finished_clicked',
    'finished_schedulings_filter_clicked',
    'finished_schedulings_filter_submitted',
    'finished_schedulings_card_call_clicked',
    'finished_schedulings_card_send_message_clicked',
    'finished_schedulings_card_send_proposal_clicked',
    'finished_schedulings_finish_visit_clicked',
    'chat_lr_clicked',
  ],
  timeBlock: [
    'time_block_page_viewed',
    'time_block_add_clicked',
    'time_block_delete_clicked',
    'time_block_confirmed',
    'time_block_action_clicked',
    'TIME_BLOCK_TAB_CHANGED',
    'TIME_BLOCK_PAGE_INFO_CLICKED',
    'TIME_BLOCK_NEW_BLOCK_CLICKED',
  ],
  support: [
    'tta_page_viewed',
    'tta_card_opened',
    'tta_status_changed',
    'tta_search_typed',
    'tta_next_page_clicked',
    'agent_support_dialog_opened',
    'agent_support_dialog_closed',
    'agent_support_create_chat_clicked',
  ],
  clientGrids: [
    'my_clients_page_viewed',
    'my_clients_card_opened',
    'my_clients_next_page_clicked',
    'clients_proposal_stage_page_viewed',
    'clients_proposal_stage_search_typed',
    'clients_proposal_stage_expand_card_clicked',
    'clients_proposal_stage_send_message_link_clicked',
    'clients_proposal_stage_view_profile_link_clicked',
    'clients_proposal_stage_sort_by_recent_clicked',
    'clients_proposal_stage_sort_by_oldest_clicked',
    'clients_proposal_stage_next_page_clicked',
    'clients_proposal_stage_previous_page_clicked',
    'clients_scheduled_visit_page_viewed',
    'clients_scheduled_visit_search_typed',
    'clients_scheduled_visit_sorting_link_clicked',
    'clients_scheduled_visit_sort_by_next_visits_clicked',
    'clients_scheduled_visit_sort_by_latest_clients_clicked',
    'clients_scheduled_visit_sort_by_alphabetical_order_clicked',
    'clients_scheduled_visit_expand_card_clicked',
    'clients_scheduled_visit_send_message_link_clicked',
    'clients_scheduled_visit_view_profile_link_clicked',
    'clients_scheduled_visit_next_page_clicked',
    'clients_scheduled_visit_previous_page_clicked',
  ],
  visitorInfo: [
    'visitorinfo_page_viewed',
    'visitorinfo_whatsapp_clicked',
    'visitorinfo_phone_clicked',
    'visitorinfo_last_visits_card_send_offer_clicked',
  ],
  whatsapp: [
    'saleagent_visitdetails_talktotenant_button_clicked',
    'saleagent_visitdetails_tips_talktotenant_button_clicked',
    'whtsppciqtpa_agentspwa_pagevisita_clicked',
    'whtsppciqtpa_agentspwa_pageimovel_clicked',
    'chatcrpp_access_chat_clicked',
    'chatcrpp_access_chat_lr_clicked',
    'chatcrpp_access_allchats_clicked',
  ],
  global: [
    'logout_pwa',
    'MY_SERVICE_LINK_EVENTS.COPY_LINK_CLICKED',
    'MY_SERVICE_LINK_EVENTS.PAGE_VIEWED',
  ],
  feedback: [
    'create_chat_failure_snackbar_viewed',
    'create_chat_failure_retry_clicked',
    'offer_link_success',
    'offer_link_failure',
    'unread_messages_snackbar_viewed',
    'unread_messages_snackbar_open_clicked',
  ],
});

const unique = values => [...new Set(values)];

export const QUINTO_TRACKING_EVENT_NAMES = Object.freeze(
  unique(Object.values(QUINTO_TRACKING_EVENT_FAMILIES).flat())
);

export const isQuintoTrackingEvent = event =>
  QUINTO_TRACKING_EVENT_NAMES.includes(event);

export const trackQuintoEvent = (track, event, properties = {}) => {
  if (typeof track !== 'function') return null;
  return track(event, {
    source: 'quinto_parity',
    parity_event: isQuintoTrackingEvent(event),
    ...properties,
  });
};

const isPresent = value => value === false || Boolean(value);

export const createNamedTrackingEvent = ({
  event,
  variants = { default: {} },
  required = [],
}) => {
  const allowedVariants = Object.keys(variants);

  return Object.freeze({
    event,
    required,
    variants: allowedVariants,
    create(variant = 'default', data = {}) {
      if (!Object.prototype.hasOwnProperty.call(variants, variant)) {
        throw new TypeError(
          `Only these variants are compatible with ${event}: ${allowedVariants.join(', ')}`
        );
      }

      const payload = {
        ...variants[variant],
        ...data,
      };
      const missing = required.filter(key => !isPresent(payload[key]));
      if (missing.length) {
        throw new Error(`${event} requires: ${missing.join(', ')}`);
      }

      return {
        event,
        ...payload,
      };
    },
  });
};

export const LAIS_TRACKING_CREATORS = Object.freeze({
  listingClicked: createNamedTrackingEvent({
    event: LAIS_TRACKING_EVENTS.LISTING_CLICKED,
    variants: {
      index_card: { action: 'LISTING CARD CLICKED' },
      detail_header: { action: 'LISTING DETAIL VIEWED' },
    },
    required: ['listingId'],
  }),
  listingQuickFilterClicked: createNamedTrackingEvent({
    event: LAIS_TRACKING_EVENTS.LISTING_QUICK_FILTER_CLICKED,
    variants: {
      catalog_filter: { action: 'LISTING FILTER CLICKED' },
      recent_search: { action: 'RECENT SEARCH CLICKED' },
    },
    required: ['filter'],
  }),
  pageViewed: createNamedTrackingEvent({
    event: LAIS_TRACKING_EVENTS.PAGE_VIEWED,
    variants: {
      router_after_each: { action: 'SPA PAGE VIEWED' },
    },
    required: ['name', 'path'],
  }),
});

export const listingTrackingPayload = (imovel = {}, extras = {}) => ({
  listingId: imovel.id || imovel.listingId || imovel.listing_id,
  finalidade: imovel.finalidade,
  cidade: imovel.cidade,
  bairro: imovel.bairro,
  catalog: extras.catalog,
  sourceList: extras.sourceList,
  ...extras,
});

export const quickFilterTrackingPayload = (filter, properties = {}) => ({
  filter,
  ...properties,
});

export default LAIS_TRACKING_EVENTS;
